import { render, staticRenderFns } from "./WorkspaceAreaLeft.vue?vue&type=template&id=0edcce9a&scoped=true&"
import script from "./WorkspaceAreaLeft.vue?vue&type=script&lang=js&"
export * from "./WorkspaceAreaLeft.vue?vue&type=script&lang=js&"
import style0 from "./WorkspaceAreaLeft.vue?vue&type=style&index=0&id=0edcce9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0edcce9a",
  null
  
)

export default component.exports